import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FormSubmitButton } from "shared/components/button/FormSubmitButton";
import {
  FormFooter,
  FormFooterActions,
  FormFooterBreadcrumb,
} from "shared/components/form/FormFooter";
import {
  PageWizardBar,
  usePageWizard,
} from "shared/components/layout/PageWizard";

export const WaterfallHybridFooter: React.FC<{
  onContinue?: () => void;
  isWaterfallLoading?: boolean;
}> = ({ onContinue, isWaterfallLoading }) => {
  const { t } = useTranslation(["common", "waterfall"]);
  const { navigateBack, canGoNext, exit, canGoBack } = usePageWizard();

  return (
    <FormFooter>
      <FormFooterBreadcrumb>
        <PageWizardBar allowNavigate={false} />
      </FormFooterBreadcrumb>
      <FormFooterActions>
        {canGoBack && (
          <Button colorScheme="secondary" onClick={navigateBack}>
            {t("common:back")}
          </Button>
        )}
        <Button colorScheme="secondary" onClick={exit}>
          {t("common:exit")}
        </Button>
        {canGoNext && !onContinue && (
          <FormSubmitButton>{t("common:save")}</FormSubmitButton>
        )}
        {onContinue && (
          <Button onClick={onContinue} isLoading={isWaterfallLoading}>
            {t(
              "waterfall:waterfallClassifications.summary.continueToWaterfall",
            )}
          </Button>
        )}
      </FormFooterActions>
    </FormFooter>
  );
};
